// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"6b6813d0","453":"37979d1f"}[chunkId] + ".chunk.js";
};